import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnBadge from "../toolbox/CgnBadge";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {
  localFilePath,
  URL,
  
  machineProductUnits,
  machineProductStatuses,
  CategoryList,
  fotoStyle,
} from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnButtonLinkGroup from "../toolbox/CgnButtonLinkGroup";
import noImg from "../../images/no-img.png";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnButton from "../toolbox/CgnButton";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import CgnTextbox from "../toolbox/CgnTextbox";

class MachineProductLocationList extends Component {
  state = {
    pageTitle: "Ürün Listele",
    pageDetailLink: "urun3-depo-detay",
    pageListLink: "depomdaki-urunler",
    breadcrumb: [{ text: "Depom", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    productData: [],
    name: "",
    categoryName: "",
    salePrice: "",
    guid: "",
    currencyType: 0,
    alertErrorMessage: "",
    activeTab: "1",
    categoryArr: [],
    categoryGuid: "00000000-0000-0000-0000-000000000000",
    unit: "",
    productStatus: "",
    image: "",
    isOpen: false,
    isOpenModalRemoveToLocation: false,
    description: "",
    descriptionError: "",
    alertErrorModalMessage: "",
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });

    var self = this;

    await CategoryList().then(function (data) {
      self.setState({
        categoryArr: data,
      });
    });

    if (localStorage.getItem("categoryGuidMachineProduct")) {
      this.setState({
        categoryGuid: localStorage.getItem("categoryGuidMachineProduct"),
      });
    }

    this.getList(null);
  }

  toggle = (image, name) => {
    this.setState({
      isOpen: !this.state.isOpen,
      image: image,
      name: name,
    });
  };

  // async componentDidUpdate() {
  //   let urlSplit = window.location.pathname.split("/");
  //   if (urlSplit.length === 3) {
  //     if (this.state.categoryGuid !== urlSplit[urlSplit.length - 1]) {
  //       await this.setState({
  //         isLoading: true,
  //         categoryGuid: urlSplit[urlSplit.length - 1],
  //       });
  //       this.state.categoryArr.forEach((item) => {
  //         if ("/urun3-listele/" + this.state.categoryGuid === item.to) {
  //           item.color = "primary";
  //         } else {
  //           item.color = "secondary";
  //         }
  //       });
  //       this.getList();
  //     }
  //   } else if (urlSplit.length === 2) {
  //     if (this.state.categoryGuid !== null) {
  //       await this.setState({
  //         isLoading: true,
  //         categoryGuid: null,
  //       });
  //       this.state.categoryArr.forEach((item) => {
  //         if ("/urun3-listele" === item.to) {
  //           item.color = "primary";
  //         } else {
  //           item.color = "secondary";
  //         }
  //       });
  //       this.getList();
  //     }
  //   }
  // }

  getList = async () => {
    this.setState({
      isLoading: true,
    });
    if (this.state.unit === "") {
      this.state.unit = 0;
    }
    if (this.state.productStatus === "") {
      this.state.productStatus = 0;
    }
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    var statusType = 2;
    URLParam =
      "/machineProducts/getlist/" +
      statusType +
      "/" +
      this.state.categoryGuid +
      "/" +
      this.state.unit +
      "/" +
      this.state.productStatus;

    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        this.setState({
          productData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/machineProducts/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleCopyProduct = async (guid) => {
    confirmAlert({
      title: CgnMessage.copyQuestionTitle,
      message: CgnMessage.copyQuestionMessage,
      buttons: [
        {
          label: CgnMessage.copyQuestionYes,
          onClick: () => this.copyItem(guid),
        },
        {
          label: CgnMessage.copyQuestionNo,
        },
      ],
    });
  };

  async copyItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/machineProducts/copy/" + guid, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleAddToCart = async (row) => {
    let productData = this.state.productData;
    if (
      row.guid &&
      row.piece &&
      row.piece !== 0
    ) {
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(
          URL +
          "/machineproducts/addtocart/" +
          row.guid +
          "/" +
          row.piece,
          config
        )
        .then((response) => {
          this.props.data.cartCount =
            this.props.data.cartCount + row.piece;
          row.piece = 1;
          this.setState({
            productData: productData,
          });
          confirmAlert({
            title: CgnMessage.alertSuccessTitle,
            message: CgnMessage.addToCartSuccessMessage,
            buttons: [
              {
                label: CgnMessage.closeButton,
              },
            ],
          });
        })
        .catch((error) => {
          confirmAlert({
            title: CgnMessage.alertErrorTitle,
            message: error.response.data,
            buttons: [
              {
                label: CgnMessage.closeButton,
                onClick: () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              },
            ],
          });
        });
    }
  };

  async handleCategorySelectChange(option) {
    if (option) {
      await this.setState({
        categoryGuid: option.value,
      });
    } else {
      await this.setState({
        categoryGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("categoryGuidMachineProduct", this.state.categoryGuid);
  }

  async handleUnitSelectChange(option) {
    if (option) {
      await this.setState({
        unit: option.value,
      });
    } else {
      await this.setState({
        unit: 0,
      });
    }
    localStorage.setItem("unitMachineProduct", this.state.unit);
  }

  async handleProductStatusSelectChange(option) {
    if (option) {
      await this.setState({
        productStatus: option.value,
      });
    } else {
      await this.setState({
        productStatus: 0,
      });
    }
    localStorage.setItem(
      "productStatusMachineProduct",
      this.state.productStatus
    );
  }

  handlePdfPrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/machineProducts/productPrint/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleBarcodePrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/machineProducts/barcodenumberprint/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleProductPieceTextBoxChange(e, row) {
    let productData = this.state.productData;
    row.piece = parseFloat(e.target.value);
    this.setState({
      productData: productData,
    });
  }

  handleRemoveToLocation = async (idx) => {
    let productData = this.state.productData;
    if (idx !== -1 && !this.state.isOpenModalRemoveToLocation) {
      if (
        productData[idx].guid &&
        productData[idx].piece &&
        productData[idx].piece !== 0
      ) {
        this.setState({
          idxModal: idx,
          guidModal: productData[idx].guid,
          pieceModal: productData[idx].piece,
          isOpenModalRemoveToLocation: true,
        });
      }
    }
  };

  addRemoveToLocation = () => {
    this.setState({
      isOpenModalRemoveToLocation: !this.state.isOpenModalRemoveToLocation,
    });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      descriptionError: "",
      alertErrorModalMessage: "",
    });
  };

  handleSaveRemoveToLocation = async () => {
    this.setState({
      alertErrorModalMessage: "",
    });

    if (this.state.description === "") {
      this.setState({
        descriptionError: CgnMessage.textErrorMessage,
        alertErrorModalMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.description !== "") {
      this.setState({
        isOpenModalRemoveToLocation: false,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        locationGuid: localStorage.getItem("locationGuid"),
        machineProductGuid: this.state.guidModal,
        piece: this.state.pieceModal,
        description: this.state.description,
        status: true,
      };
      axios
        .post(URL + "/machinestockremove/add", myObj, config)
        .then(() => {
          let productData = this.state.productData;
          productData[this.state.idxModal].piece = 1;
          this.setState({
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorModalMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  thStyle = {
    width: "130px",
  };

  thStyle2 = {
    width: "145px",
  };

  tdStyle = {
    width: "400px",
  };

  tdStyle2 = {
    width: "300px",
  };

  textAreaStyle = {
    padding: "5px 10px",
    height: "100px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          //addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="productList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <Row className="filterRow">
                <Col className="pl-2 pr-2" lg="6">
                  <CgnReactSelect
                    name="categoryGuid"
                    label="Kategori"
                    placeholder="Kategori seçiniz..."
                    selectValue={this.state.categoryGuid}
                    isMulti={false}
                    isClearable={true}
                    onChange={(option) =>
                      this.handleCategorySelectChange(option)
                    }
                    options={this.state.categoryArr}
                  />
                </Col>
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="unit"
                    label="Birim"
                    placeholder="Birim seçiniz..."
                    selectValue={this.state.unit}
                    isMulti={false}
                    isClearable={true}
                    onChange={(option) => this.handleUnitSelectChange(option)}
                    options={machineProductUnits}
                  />
                </Col>
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="productStatus"
                    label="İthal/Yerli/Sarf"
                    placeholder="Durum seçiniz..."
                    selectValue={this.state.productStatus}
                    isMulti={false}
                    isClearable={true}
                    onChange={(option) =>
                      this.handleProductStatusSelectChange(option)
                    }
                    options={machineProductStatuses}
                  />
                </Col>
                <Col className="pl-2 pr-0">
                  <CgnButton
                    type="button"
                    color="primary"
                    onClick={this.getList}
                    text="Listele"
                    className="listButton"
                  />
                </Col>
              </Row>

              <CgnDatatable
                data={this.state.productData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Fotoğraf",
                    selector: "image",
                    sortable: false,
                    width: "80px",
                    cell: (cell) => (
                      <div>
                        {cell.image ? (
                          <Button
                            onClick={() => this.toggle(cell.image, cell.name)}
                            className="modalButtonList"
                          >
                            <img
                              alt={cell.name}
                              src={`/Images/${cell.image}`}
                              className="rdt_image rounded"
                            />
                          </Button>
                        ) : (
                          <img
                            alt={cell.name}
                            src={noImg}
                            className="rdt_image rdt_no_image rounded"
                          />
                        )}
                      </div>
                    ),
                  },
                  {
                    name: "Ürün Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Ürün Kodu</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>{row.code}</td>
                              <th style={this.thStyle2}>Kategori Ad</th>
                              {/* <th className="colon">:</th> */}
                              <td>{row.categoryName}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ürün Adı</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>{row.name}</td>
                              <th style={this.thStyle2}>Yabancı Ürün Adı</th>
                              {/* <th className="colon">:</th> */}
                              <td>{row.foreignName ? row.foreignName : "-"}</td>
                            </tr>

                            <tr>
                              <th style={this.thStyle}>Birim</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>
                                {row.unit === 1
                                  ? "Adet"
                                  : row.unit === 2
                                    ? "Metre"
                                    : row.unit === 3
                                      ? "Kilogram"
                                      : "-"}
                              </td>
                              <th style={this.thStyle2}>Durum</th>
                              {/* <th className="colon">:</th> */}
                              <td>
                                {row.productStatus === 1
                                  ? "İthal"
                                  : row.productStatus === 2
                                    ? "Yerli"
                                    : row.productStatus === 3
                                      ? "Saf"
                                      : "-"}
                              </td>
                            </tr>

                            <tr>
                              <th style={this.thStyle}>Stok Durumu</th>
                              <td style={this.tdStyle}>
                                {row.stockStatus === 2
                                  ? "Stoklu Ürün (Zorunlu)"
                                  : row.stockStatus === 1
                                    ? "Stoklu Ürün"
                                    : "Stoksuz Ürün"}
                              </td>
                              <th style={this.thStyle2}>Kritik Stok</th>
                              <td>{row.criticalPieces}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              <td colSpan={3}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    width: "75px",
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, idx) => (
                      <CgnTextbox
                        type="number"
                        className="dataTableInput"
                        name="piece"
                        value={row.piece}
                        placeHolder="Adet"
                        maxLength="100"
                        autoComplete="off"
                        onChange={(e) =>
                          this.handleProductPieceTextBoxChange(e, row)
                        }
                        error={row.pieceError}
                      />
                    ),
                  },
                  {
                    width: "125px",
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, idx) => (
                      <CgnButton
                        text={"Sepete Ekle"}
                        type="button"
                        className="w-100 ml-0"
                        color="warning"
                        onClick={() => this.handleAddToCart(row)}
                      />
                    ),
                  },
                  // {
                  //   width: "175px",
                  //   ignoreRowClick: true,
                  //   allowOverflow: true,
                  //   button: true,
                  //   cell: (row, idx) => (
                  //     <CgnButton
                  //       text={"Depomdan Çıkar"}
                  //       type="button"
                  //       className="w-100 ml-0"
                  //       color="danger"
                  //       onClick={() => this.handleRemoveToLocation(idx)}
                  //     />
                  //   ),
                  // },
                  {
                    width: "125px",
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonLink
                        text={"Detay"}
                        type="button"
                        className="w-100 ml-0"
                        color="primary"
                        to={"/" + this.state.pageDetailLink + "/" + row.guid}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
        <Modal
          className="modal-xs"
          isOpen={this.state.isOpen}
          toggle={this.toggle}
        >
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <img
            className="modalImage"
            src={`/Images/${this.state.image}`}
            style={fotoStyle}
            alt={this.state.name}
          />
        </Modal>
        <Modal
          isOpen={this.state.isOpenModalRemoveToLocation}
          toggle={this.addRemoveToLocation}
          className="modal-xs content"
        >
          <ModalBody className="modalBody">
            <CgnTextbox
              inlineStyle={this.textAreaStyle}
              type="textarea"
              name="description"
              label="Depodan Çıkarma Sebebi"
              value={this.state.description}
              placeHolder="Lütfen depodan çıkarma sebebinizi girin..."
              autoComplete="off"
              onChange={this.handleChange}
              error={this.state.descriptionError}
            />
            {this.state.alertErrorModalMessage && (
              <CgnAlert
                color="danger"
                title={CgnMessage.alertErrorTitle}
                text={this.state.alertErrorModalMessage}
              />
            )}
            <CgnButton
              type="button"
              color="primary"
              onClick={this.handleSaveRemoveToLocation}
              text="Kaydet"
              className="modalButton"
            />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addRemoveToLocation}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default MachineProductLocationList;
